import { render, staticRenderFns } from "./VGame.vue?vue&type=template&id=77a18f0d&scoped=true&"
import script from "./VGame.vue?vue&type=script&lang=js&"
export * from "./VGame.vue?vue&type=script&lang=js&"
import style0 from "./VGame.vue?vue&type=style&index=0&id=77a18f0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a18f0d",
  null
  
)

export default component.exports